import { render, staticRenderFns } from "./PlayRecord.vue?vue&type=template&id=25f10b1e&scoped=true"
import script from "./PlayRecord.vue?vue&type=script&lang=js"
export * from "./PlayRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f10b1e",
  null
  
)

export default component.exports